<template>
  <portal to="modal">
    <transition name="fade">
      <div
        v-if="isModalVisible"
        class="i-modal"
        :style="style"
        @mousedown.self.stop="onBackgroundClick"
        @click.stop
        @touchstart.stop
        @scroll.stop
      >
        <slot />
      </div>
    </transition>
  </portal>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'IModal',
  props: {
    bgcolor: {
      type: String,
      default: ''
    },
    closeable: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    ...mapGetters('arview', [
      'isArViewPopupActive'
    ]),
    style () {
      const backgroundColor = this.bgcolor

      return {
        backgroundColor
      }
    },
    isModalVisible () {
      return this.visible && !this.isArViewPopupActive
    }
  },
  methods: {
    show () {
      this.visible = true
      this.$nextTick(() => {
        this.$emit('opened')
      })
    },
    hide () {
      this.visible = false
      this.$nextTick(() => {
        this.$emit('closed')
      })
    },
    onBackgroundClick () {
      if (!this.closeable) return
      this.hide()
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '.~css/addon/main'

.i-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  z-index: 99;
}
</style>
